import $ from "jquery";

//console.log( 'secure page' );
